import { useMemo } from 'react';

import { useLanguage } from '@/hooks/user';
import { supportedLanguages } from '@/i18next';
import flags from '@/icons/icon-language.svg';
import { capitalize } from '@/utils';

export function useLanguageOptions(short) {
	const language = useLanguage();

	return useMemo(() => {
		const displayName = new Intl.DisplayNames([language], {
			type: 'language'
		});

		const parseLabel = label => {
			if (short) {
				const shortened = displayName.of(label || '').slice(0, 3);
				return capitalize(shortened);
			}

			return capitalize(displayName.of(label || ''));
		};

		return supportedLanguages
			.map(lng => ({
				value: lng,
				label: parseLabel(lng),
				flags
			}))
			.sort((a, b) => a.label.localeCompare(b.label, language));
	}, [language]);
}

export { flags };
